import xanaliaDex from 'blockchain/contract/xanalia-dex'
import Tabs from 'components/tabs'
import { useEffect } from 'react'
import { Button, Spinner, Tab } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getAllWhitelist, updateStatusWhitelist } from 'services/admin'
import { IStatusData } from 'services/type'
import { selectNetwork } from 'store/network/selectors'
import { selectWhitelist } from 'store/whitelist/selectors'
import { setLoadingSC, setStatus } from 'store/whitelist/whitelistSlice'
import { switchChain } from 'wallet/ether'

async function updateApproved(address: string, networkId: number) {
  try {
    const rest = await updateStatusWhitelist({
      address,
      status: IStatusData.APPROVED,
      networkId,
    }).catch(() => {})
    if (!rest || !(rest.status >= 200 && rest.status <= 299)) return false

    return true
  } catch (error) {
    console.error(error)
    return false
  }
}

export default function WhitelistHeader({
  onContractHasBeenSent,
}: {
  onContractHasBeenSent?: () => void
}) {
  const { status, isLoading, isLoadingSC } = useSelector(selectWhitelist)
  const { networks } = useSelector(selectNetwork)
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const listStatus: Array<string | number> = Object.keys(IStatusData)
    .map((key) => IStatusData[key as any])
    .filter((key) => typeof key === 'number')

  async function sendToContract() {
    if (isLoading) return
    dispatch(setLoadingSC(true))
    try {
      const whitelistPending = await getAllWhitelist({
        status: IStatusData.PENDING,
      }).then((obj) => obj?.data?.data || [])

      if (!whitelistPending || !whitelistPending.length) {
        return
      }

      const chains: number[] = []
      whitelistPending.forEach((obj) => {
        if (!chains.includes(obj.networkId!)) chains.push(obj.networkId!)
      })

      for (let i = 0; i < chains.length; i++) {
        const network = networks.find((obj) => obj.id === chains[i])
        if (!network) continue
        const switched = await switchChain(network.chainId)
        if (!switched) continue

        const data = whitelistPending.filter(
          (obj) => obj.networkId === network.id
        )

        const listAddress = data.map((obj) => obj.walletAddress)
        const listStatus = data.map(() => true)
        const [resolve, reject] = await xanaliaDex
          .setWhitelistAddress(network.chainId, listAddress, listStatus)
          .catch((err) => err)

        if (reject || !resolve) {
          continue
        }

        await resolve.wait(1)

        await Promise.all(
          data.map((obj) => updateApproved(obj.walletAddress, obj.networkId!))
        )
      }
    } catch (error) {
      console.log(error)
    } finally {
      dispatch(setLoadingSC(false))
      if (onContractHasBeenSent) onContractHasBeenSent()
    }
  }

  function getNameOfStatus(status?: IStatusData) {
    switch (status) {
      case IStatusData.PENDING:
        return 'PENDING_REQUEST'
      case IStatusData.APPROVED:
        return 'SENT_TO_CONTRACT'
      case IStatusData.DISAPPROVED:
        return 'DISAPPROVED'
      default:
        return undefined
    }
  }

  useEffect(() => {
    return () => {
      dispatch(setStatus(IStatusData.PENDING))
    }
  }, [])

  return (
    <div className='wa__header'>
      <Tabs
        transition={false}
        onSelect={(eve: any) => {
          if (!isLoading && !isLoadingSC) dispatch(setStatus(eve))
        }}
        activeKey={status}
        defaultActiveKey={status}
        className='me-auto'
      >
        {listStatus.map((key, i) => (
          <Tab
            key={i}
            eventKey={key}
            title={t(getNameOfStatus(key as any) || '')}
          />
        ))}
      </Tabs>

      {status == IStatusData.PENDING && (
        <Button
          className='wa__send-to-contract'
          onClick={sendToContract}
          disabled={isLoadingSC}
        >
          {isLoadingSC ? <Spinner animation='border' /> : t('SEND_TO_CONTRACT')}
        </Button>
      )}
    </div>
  )
}
